import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef, ContentChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { DateRangePicker } from '@syncfusion/ej2-calendars';
import { Template } from '@syncfusion/ej2-angular-base';
import { PresetsDirective } from './presets.directive';

export const /** @type {?} */ inputs: string[] = ['allowEdit','calendarMode','cssClass','dayHeaderFormat','depth','enablePersistence','enableRtl','enabled','endDate','firstDayOfWeek','floatLabelType','format','htmlAttributes','keyConfigs','locale','max','maxDays','min','minDays','placeholder','presets','readonly','separator','showClearButton','start','startDate','strictMode','value','weekNumber','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['blur','change','close','created','destroyed','focus','navigated','open','renderDayCell','select','startDateChange','endDateChange','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['startDate', 'endDate', 'value'];
/**
 * Represents the Essential JS 2 Angular DateRangePicker Component.
 * ```html
 * <ejs-daterangepicker [startDate]='date' [endDate]='date'></ejs-daterangepicker>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class DateRangePickerComponent extends DateRangePicker implements IComponentBase {
public childPresets: any;
public tags: string[] = ['presets'];
public startDateChange: any;
public endDateChange: any;
public valueChange: any;
/**
 * Specifies the initial view of the Calendar when it is opened. 
 * With the help of this property, initial view can be changed to year or decade view.
 * \@default Month
 */
@Template()
    public start: any;
    
    @Template()
public end: any;
private skipFromEvent:boolean = true;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-daterangepicker',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateRangePickerComponent),
            multi: true
        }
    ],
    queries: {
        childPresets: new ContentChild(PresetsDirective)
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'start': [{ type: ContentChild, args: ['start', ] },],
'end': [{ type: ContentChild, args: ['end', ] },],
};
}

function DateRangePickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
DateRangePickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateRangePickerComponent.ctorParameters;
/** @type {?} */
DateRangePickerComponent.propDecorators;
/** @type {?} */
DateRangePickerComponent.prototype.childPresets;
/** @type {?} */
DateRangePickerComponent.prototype.tags;
/** @type {?} */
DateRangePickerComponent.prototype.startDateChange;
/** @type {?} */
DateRangePickerComponent.prototype.endDateChange;
/** @type {?} */
DateRangePickerComponent.prototype.valueChange;
/**
 * Specifies the initial view of the Calendar when it is opened. 
 * With the help of this property, initial view can be changed to year or decade view.
 * \@default Month
 * @type {?}
 */
DateRangePickerComponent.prototype.start;
/** @type {?} */
DateRangePickerComponent.prototype.end;
/** @type {?} */
DateRangePickerComponent.prototype.skipFromEvent;
/** @type {?} */
DateRangePickerComponent.prototype.registerEvents;
/** @type {?} */
DateRangePickerComponent.prototype.addTwoWay;
/** @type {?} */
DateRangePickerComponent.prototype.ngEle;
/** @type {?} */
DateRangePickerComponent.prototype.srenderer;
/** @type {?} */
DateRangePickerComponent.prototype.viewContainerRef;
/** @type {?} */
DateRangePickerComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
